import React from 'react';

interface ISVGCheckCircleProps {
    isChecked: boolean;
    handleClick: () => void;
}

const SVGCheckCircle = ({ isChecked, handleClick }: ISVGCheckCircleProps) => (
    <button
        className="flex w-[40px] h-[40px] relative items-center justify-center"
        onClick={handleClick}
        onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
                handleClick();
            }
        }}
        tabIndex={0}
        aria-pressed={isChecked}
    >
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[40px] h-[40px]"
            preserveAspectRatio="none"
        >
            <circle cx="20" cy="20" r="18" fill="#EAE7F9" />

            {isChecked && (
                <path
                    d="M13 20L18 25L28 15"
                    stroke="#5637CD"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            )}
        </svg>
    </button>
);

export default SVGCheckCircle;
